import { render, staticRenderFns } from "./AdvantageItem.vue?vue&type=template&id=7d52917a&scoped=true&"
import script from "./AdvantageItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AdvantageItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AdvantageItem.vue?vue&type=style&index=0&id=7d52917a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d52917a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d52917a')) {
      api.createRecord('7d52917a', component.options)
    } else {
      api.reload('7d52917a', component.options)
    }
    module.hot.accept("./AdvantageItem.vue?vue&type=template&id=7d52917a&scoped=true&", function () {
      api.rerender('7d52917a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuAdvantages/components/AdvantageItem.vue"
export default component.exports